import { ServiceIcon } from "@/components/shared/service-icon";
import { Card, CardContent } from "@/components/ui/card";
import { Text, View } from "@/components/ui";
import { AllServicesModal } from "../all-services";
import { serviceItemsSectionThree } from "../lib";
import { useRoute } from "@/components/shared/router";
import { getPlatform, cn } from "@/lib/utils";
import { useMemo, useState } from "react";
import { SquaresFour } from "@/components/shared/icons";

function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function OtherServices() {
  const { push } = useRoute();
  const [modalOpen, setModalOpen] = useState(false);
  const shuffledServices = useMemo(
    () => shuffleArray(serviceItemsSectionThree()).slice(0, 4),
    [],
  );
  function handleOpenChange(newState: boolean) {
    setModalOpen(newState);
  }
  return (
    <Card shadow="sm">
      <CardContent className="flex flex-col border-b border-border p-3">
        <View className="flex flex-row flex-wrap">
          {shuffledServices.map((service, index: number) => (
            <View
              className={cn(
                "w-1/4",
                index === 0 ? "pl-0 pr-2" : index === 3 ? "pl-2 pr-0" : "px-2",
              )}
              key={service.name}
            >
              <ServiceIcon {...service} />
            </View>
          ))}
        </View>
      </CardContent>
      <CardContent className="flex flex-col p-0">
        <View
          className="flex flex-row items-center justify-center gap-2 p-2"
          onClick={() => {
            if (getPlatform() === "web") {
              setModalOpen(true);
              return;
            }
            push({ pageKey: "allServices" });
          }}
        >
          <Text className="cursor-pointer text-xs font-medium text-brand-primary md:text-base">
            View all
          </Text>
          <SquaresFour size={16} weight="fill" className="color-primary" />
        </View>
      </CardContent>
      <AllServicesModal
        modalOpen={modalOpen}
        handleOpenChange={handleOpenChange}
      />
    </Card>
  );
}
